module.exports = __webpack_public_path__ + "img/aquatic-staff-6.0a8e6152.jpg";